import { attribute, attributeGetter, Component } from "@bodil/dom/component";
import type { Role } from "aria-attribute-types";
import { html } from "lit";
import { customElement } from "lit/decorators.js";

import styles from "./layout.css?inline";

declare global {
    interface HTMLElementTagNameMap {
        "btk-layout": BtkLayout;
    }
}

export type LayoutDirection = "x" | "y";
export type LayoutAlign =
    | "start"
    | "center"
    | "end"
    | "space-between"
    | "space-around"
    | "space-evenly";

export type LayoutInlineAlign = "start" | "center" | "end" | "baseline" | "stretch" | "normal";

@customElement("btk-layout")
export class BtkLayout extends Component {
    @attribute({ reflect: false }) accessor dir: LayoutDirection = "x";
    @attribute({ reflect: false }) accessor align: LayoutAlign = "space-between";
    @attribute({ reflect: false }) accessor inline: LayoutInlineAlign = "normal";

    @attributeGetter get role(): Role {
        return "presentation";
    }

    render() {
        return html`<slot></slot>`;
    }

    static styles = styles;
}
